import * as types from "./types";
import { orderDetailsPath, contactPath, orderLinesPath, backordersPath } from './state';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';

import { set } from 'lodash';
export const orderMutations = {
  [types.DistributionOrderList.SET.ALL](state, payload) {
    state.distributionOrderList = payload;
    if (state.order_types) {
      state.distributionOrderList.orders = state.distributionOrderList.orders.map(e => {
        const order_type_name = state.order_types.find(x => x.value == e.order_type);
        if (order_type_name) {
          return {
            ...e,
            order_type_name: order_type_name.label
          }
        }
        return {
          ...e,
          order_type_name: ''
        }
      })
    } else {
      state.distributionOrderList.orders = state.distributionOrderList.orders.map(e => {
        return {
          ...e,
          order_type_name: ''
        }
      })
    }
  },
  // [types.DistributionOrderList.INSERT.SINGLE](state, payload) {
  //   state.distributionOrderList.orders = payload.sort((a, b) =>a.order_id>b.order_id);
  // },
  [types.DistributionOrderList.DELETE.SINGLE](state, payload) {
    const { orderId } = payload;
    if (!orderId) {
      return;
    }
    state.orders = state.orders.filter(a => a.order_id != orderId);
  },
  [types.SET_ORDER_TAB_DATA](state, payload) {
    state.accountList = payload.accounts;
    state.orderDateList = getMonths(new Date(payload.order_dates.min_date), new Date(payload.order_dates.max_date));
    state.orderStatusList = payload.order_status;

  },
  [types.SET_ORDERLINES_FROM_DATA](state, payload) {


  },
  [types.DistributionOrderList.SET.SINGLE](state, payload) {
    set(state, orderDetailsPath, payload);
  },
  [types.INVOICE_CONTACT.SET.ALL](state, payload) {
    set(state, contactPath, payload);
  },
  [types.ORDER_LINES.SET.ALL](state, payload) {
    set(state, orderLinesPath, payload);
  },
  [types.BACKORDERS.SET.ALL](state, payload) {
    set(state, backordersPath, payload);
  },
  [types.SET_ORDER_DETAILS](state, value) {
    state.orderDetailsFlag = value;
  },
  [types.SELECTED_ORDER.SET.SINGLE](state, payload) {
    set(state, orderDetailsPath, payload);

  },

  [types.CLEAR_SELECTED_ORDER_DATA](state, payload) {
    state.selectedOrderData = {
      ...payload
    }
  },
  [types.SET_SELECTED_ORDER_DATA](state, payload) {

    state.selectedOrderData = {
      ...state.selectedOrderData,
      ...payload
    }
  },
  [types.SET_MULTI_ORDER_DATA](state, payload) {
    state.multiOrders = [
      ...payload.orders
    ],
      state.moneyAccountList = [
        ...payload.money_accounts
      ],
      state.statusList = [
        ...payload.statuses
      ]
  },
  [types.SET_FILTERED_MULTI_ORDER_DATA](state, payload) {
    state.multiOrders = [
      ...payload.orders
    ]

  },
  ...implementSetAllNavTabDetailsMutation(types.DistributionOrderDetails, 'distributionOrderDetails'),
}

export const getMonths = (fromDate, toDate) => {
  const fromYear = fromDate.getFullYear();
  const fromMonth = fromDate.getMonth();
  const toYear = toDate.getFullYear();
  const toMonth = toDate.getMonth();
  const months = [];
  for (let year = fromYear; year <= toYear; year++) {
    let month = year === fromYear ? fromMonth : 0;
    const monthLimit = year === toYear ? toMonth : 11;
    for (; month <= monthLimit; month++) {
      months.unshift({ text: `${getMonthName(month)} ${year}`, value: `${getMonthName(month)} ${year}` })
    }
  }
  return months;
}

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const getMonthName = (month) => {
  return monthNames[month]
}